const CustomerDeviceService = {
  setCustomerDevice: (customerDevice: string) => {
    sessionStorage.setItem("customerDevice", customerDevice);
  },

  getCustomerDevice: () => {
    return sessionStorage.getItem("customerDevice");
  },
};

export default CustomerDeviceService;
